import { TextField, Typography } from '@mui/material';

import { textFieldDefaultStyle } from '../../../../../../components/UI/Typography';
import {
  IconAttachFileMS,
  IconCloseMS,
} from '../../../../../../constants/icons';
import {
  CloseButtonBox,
  CloseIcon,
  DialogContainer,
  StyledDialog,
  TextTypography,
} from '../styles';

interface RejectionReasonDialogProps {
  open: boolean;
  closeDialog: () => void;
  rejectionReason: string;
  document: string;
}

export function RejectReasonDialog({
  open,
  closeDialog,
  rejectionReason,
  document,
}: RejectionReasonDialogProps): JSX.Element {
  return (
    <StyledDialog open={open} onClose={closeDialog}>
      <CloseButtonBox>
        <CloseIcon onClick={closeDialog}>{IconCloseMS}</CloseIcon>
      </CloseButtonBox>
      <DialogContainer>
        <Typography>Motivo</Typography>
        <TextTypography>
          {IconAttachFileMS}
          {document}
        </TextTypography>
        <TextField
          id="rejection-reason"
          multiline
          rows={6}
          value={rejectionReason}
          sx={textFieldDefaultStyle}
          disabled
        />
      </DialogContainer>
    </StyledDialog>
  );
}
